import { morphism } from 'morphism';

const doNotMorph = (t) => t;
const morph = async (parsedBody, morphismSchema) => {
    const morpher = morphismSchema ? morphism(morphismSchema) : doNotMorph;
    return morpher(parsedBody);
};

export { morph };
//# sourceMappingURL=requestProcessors.js.map
